/**
 * @fileOverview This file contains the implementation of the Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { useAtom } from 'jotai';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';

import { GlobalVariables } from '../globalVar';
import customAxios from '../utils/customAxios';
import Carousel from '../components/Inventory/Carousel';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import InventoryToolbar from '../components/Inventory/InventoryToolbar';
import { movementsArrayAtom } from '../stores/movementsStore';
//#endregion

const Inventory = () => {
  const { titleInventoryString } = useTranslationHook();
  const [movements, setMovements] = useAtom(movementsArrayAtom);

  const [inventoryData, setInventoryData] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filterInventoryData, setFilterInventoryData] = useState(true);

  const endpoint = `${GlobalVariables.getURL()}inventory`;

  const getInventoryData = async (endpoint) => {
    try {
      const response = await customAxios.post(
        endpoint,
        {
          filters,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );
      if (response.data.status === 'success') {
        const inventoryData = response.data.data.map((equip) => {
          return {
            ...equip,
          };
        });

        if (filterInventoryData) {
          setInventoryData(inventoryData);
        } else {
          setInventoryData(
            inventoryData.filter((equip) => equip.items.length > 0)
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getInventoryData(endpoint);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, filterInventoryData]);

  return (
    <Box height={'100%'} width={'100%'}>
      <Helmet>
        <title>{titleInventoryString}</title>
      </Helmet>
      <InventoryToolbar
        setFilters={setFilters}
        filterInventoryData={filterInventoryData}
        setFilterInventoryData={setFilterInventoryData}
        refreshData={() => getInventoryData(endpoint)}
      />
      <Box width={'100%'} height={'90%'} padding={3} sx={{ overflowY: 'auto' }}>
        {inventoryData.map((carouselData, index) => (
          <Carousel
            key={index}
            refreshItems={() => {
              getInventoryData(endpoint);
            }}
            title={carouselData.title}
            items={carouselData.items}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Inventory;
